export const usersManualPhoneVerification = '/users/phone-verification/';

export const login = '/login/';
export const signupIFrameSimple = '/signup/iframe/simple/';
export const signup = '/signup/';

export const formsGallery = '/forms-gallery/';
